<template>
  <div class="jointschool-registration">
    <b-container
      id="form-wrapper"
      @click="redirect('jointschool.app', true)"
      class="form-container form-wrapper--header"
    >
      <div id="logo" class="header">
        <div class="logo">
          <b-img :src="require('@assets/logo.png')" fluid />
        </div>
      </div>
    </b-container>

    <b-container id="form-wrapper" class="form-container">
      <b-col class="internal-container">
        <div class="intro">
          <div>
            Sign up using the simple form below. You will receive an invitation
            email with instructions on how to download the app, log in, and
            start managing your condition more effectively.
          </div>
        </div>
        <br />
        <ValidationObserver ref="observer">
          <b-form
            @reset="onReset"
            v-if="show"
            @submit.prevent="onSubmit"
            novalidate
          >
            <ValidationProvider rules="required" name="Name">
              <b-form-group
                id="input-group-1"
                label="First name (we don’t need your surname)"
                label-for="input-1"
                class="field mb-4"
                slot-scope="{ valid, errors }"
              >
                <b-form-input
                  id="input-1"
                  v-model="form.firstName"
                  :state="errors[0] ? false : valid ? true : null"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider rules="required|email" name="The email">
              <b-form-group
                id="input-group-2"
                label="Email address"
                label-for="input-2"
                class="field mb-4"
                slot-scope="{ valid, errors }"
              >
                <b-form-input
                  id="input-2"
                  v-model="form.email"
                  :state="errors[0] ? false : valid ? true : null"
                  type="email"
                  required
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider
              rules="required|password|no_space"
              name="Password"
              vid="password"
              >>
              <b-form-group
                id="input-group-3"
                label="Choose password (at least 8 characters)"
                label-for="input-3"
                class="field mb-4"
                slot-scope="{ valid, errors }"
              >
                <b-form-input
                  id="input-3"
                  v-model="form.password"
                  :state="errors[0] ? false : valid ? true : null"
                  type="password"
                  required
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider
              rules="required|confirmed:password|no_space"
              name="Confirm Password"
            >
              <b-form-group
                id="input-group-3"
                label="Confirm password"
                label-for="input-4"
                class="field mb-4"
                slot-scope="{ valid, errors }"
              >
                <b-form-input
                  id="input-4"
                  v-model="form.passwordConfirm"
                  :state="errors[0] ? false : valid ? true : null"
                  type="password"
                  required
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ "Password does not match" }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider rules="required" name="Procedure">
              <b-form-group
                id="input-5"
                label="I'm suffering from arthritis, am awaiting or recovering from surgery for my:"
                slot-scope="{ valid, errors }"
              >
                <b-form-radio-group
                  v-model="form.journey"
                  :state="errors[0] ? false : valid ? true : null"
                >
                  <b-form-radio name="knee-radio" value="knee"
                    >Knee</b-form-radio
                  >
                  <b-form-radio name="hip-radio" value="hip">Hip</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </ValidationProvider>

            <div class="checkbox-section">
              By clicking “Sign up” I confirm that I am a UK user over the age
              of 18 and I agree to msk.ai storing these details to process my
              registration, and to the
              <a
                class="link"
                href="https://appsupport.team/jointschool-terms"
                target="_blank"
                >Terms and Conditions</a
              >. Find out how msk.ai collects, uses and manages your data in our
              <span
                class="link"
                @click="redirect('appsupport.team/jointschool-privacy')"
              >
                Privacy Policy </span
              >.
            </div>

            <b-button type="submit" variant="primary" :disabled="buttonDisabled"
              >Sign up</b-button
            >
          </b-form>
        </ValidationObserver>
      </b-col>
    </b-container>
    <b-container class="footer">
      <b-row>
        <b-col>
          <div class="description">
            myrecovery is a patient app developed by msk.ai. We believe that
            sharing knowledge is essential to progress and helping patients.
            However, that must not come at the expense of people’s privacy and
            consent. We understand how important privacy is and are committed to
            ensuring all information is managed sensitively and securely. For
            patients in the UK we are GDPR compliant and follow NHS Information
            Governance guidelines. Click here for our
            <span
              class="link"
              @click="redirect('appsupport.team/jointschool-terms')"
            >
              Terms and Conditions
            </span>
            and
            <span
              class="link"
              @click="redirect('appsupport.team/jointschool-privacy')"
            >
              Privacy Policy </span
            >.
            <br />
            <br />
            msk.ai: Unit 2, 32-34 Gordon House Rd, Gospel Oak, London NW5 1LP
          </div>
          <b-img
            :src="require('@assets/logo-composition.png')"
            class="logo-composition"
            fluid
          />
        </b-col>
        <b-col sm="0" md="auto" class="spacer"></b-col>
        <b-col col lg="2" class="link-section">
          <p
            class="link about"
            @click="redirect('jointschool.app/about', true)"
          >
            About
          </p>
          <p class="link how" @click="redirect('jointschool.app/how', true)">
            How
          </p>
          <p class="link why" @click="redirect('jointschool.app/why', true)">
            Why
          </p>
          <div class="copyright">
            ©2020 msk.ai - All rights reserved.
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import axios from "axios";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import moment from "moment";

extend("required", {
  validate: (value) => {
    return !!value;
  },
  message: "{_field_} is required",
});

extend("password", {
  validate: (value) => {
    return value.length > 7;
  },
  message: "Password must be atleast 8 characters long",
});

extend("no_space", {
  validate: (value) => {
    return !/\s/.test(value);
  },
  message: "Password can not contain any spaces",
});

extend("fullname", {
  validate: (value) => {
    return value.split(" ").filter((val) => val !== "").length > 1;
  },
  message: "This field requires first and last name",
});

export default {
  name: "Registration",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      form: {},
      buttonDisabled: false,
      show: true,
    };
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }
      this.buttonDisabled = true;
      await this.submit();
    },
    redirect(url, redirect) {
      if (!!redirect) {
        window.location.href = `https://${url}`;
      } else {
        window.open(`https://${url}`, "_blank");
      }
    },
    notificationPop(message, speed) {
      this.$notify({
        group: "notification",
        type: "warn",
        duration: speed,
        text: message,
      });
    },
    submit() {
      const url = {
        qa: "https://prm-qa-gb.myrecoverytest.com/",
        stag: "https://prm-staging-gb.myrecoverytest.com/",
        production: "https://gb.api.myrecovery.ai",
      };

      axios.defaults.baseURL = url[process.env.VUE_APP_ENVIRONMENT];

      this.form.registrationTime = moment().format();
      axios
        .post("register/v1/jointschool/", this.form, {
          headers: { "Accept-Language": "en" },
        })
        .then(() => {
          window.location.href = "https://www.jointschool.app/signedup";
        })
        .catch((err) => {
          this.buttonDisabled = false;
          if (err.response && err.response.status === 400) {
            this.notificationPop(
              "That email address is already registered with the myrecovery platform. Please continue to use the myrecovery app with your existing email address, or sign up to Joint School using a different email address.",
              7000
            );
          } else {
            this.notificationPop(
              "Oops! There was an error in signing you up. Please check the form and try again.",
              4000
            );
          }
        });
    },

    onReset() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style lang="scss">
* {
  font-family: "DM Sans", sans-serif;
}
.jointschool-registration {
  .header {
    cursor: pointer;
    padding-left: 1.75vw;
    padding-top: 2.3vw;
    padding-bottom: 2rem;
    .logo {
      max-height: 150px;
      display: flex;
      img {
        max-height: 61px;
      }
    }
  }
  #form-wrapper {
    max-width: 470px;
    .intro {
      font-size: 14px;
    }
    .form-control {
      background-color: #fafafa;
    }
    .btn-primary {
      border-radius: 34px;
      background-color: #090a7a;
      width: 130px;
      height: 58px;
      margin-bottom: 34px;
    }
    #input-5 {
      margin-top: 35px;
    }
    .checkbox-section {
      margin: 22px 0;
      font-size: 12px;
      .checkbox {
        margin-bottom: 12px;
      }
    }
    .link {
      color: lightskyblue;
      &:hover {
        text-decoration: underline;
        color: navy;
      }
    }
  }
  .footer {
    color: #090a7a;
    background-color: #e6e6e6;
    margin: 0 !important;
    max-width: fit-content !important;
    padding-top: 3.3vmax;
    padding-bottom: 3.3vmax;
    padding-right: 6vw !important;
    padding-left: 3vw !important;
    .link-section {
      font-size: 1.2rem;
    }
    .copyright {
      font-size: 16px;
      margin-top: 60px;
    }
    .logo-composition {
      height: 88px;
      padding-top: 20px;
    }
    .link {
      background-repeat: repeat-x;
      background-image: linear-gradient(to right, #090a7a 100%, #090a7a 0);
      background-size: 1px 1px;
      background-position: 0 100%;
      white-space: initial;
      cursor: pointer;
      &.about {
        width: 52px;
      }
      &.how {
        width: 39px;
      }
      &.why {
        width: 40px;
      }
    }
    .description {
      font-weight: 500;
      font-style: normal;
      letter-spacing: 0em;
      text-transform: none;
      font-size: 15.6px;
    }
  }
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  position: absolute;
}
.vue-notification-group {
  width: 430px !important;
  .notification-content {
    font-size: 16px;
  }
}

@media (min-width: 768px) {
  .form-wrapper--header {
    display: flex;
    justify-content: flex-start;
    margin: 0 !important;
  }
  .spacer {
    margin: 0 61px;
  }
}
@media (max-width: 768px) {
  .link-section {
    display: inline-flex;
    .link {
      height: 26px;
      margin-right: 20px;
    }
    .spacer {
      margin: 0;
    }
  }
}
</style>
